import { render, staticRenderFns } from "./PricingAnalytics.vue?vue&type=template&id=53af1d5b&scoped=true"
import script from "./PricingAnalytics.vue?vue&type=script&lang=js"
export * from "./PricingAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PricingAnalytics.vue?vue&type=style&index=0&id=53af1d5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af1d5b",
  null
  
)

export default component.exports